import { IgrFilterExpressionCollection } from "igniteui-react-core";
import { GridFilterExpressionsEventArgs as GridFilterExpressionsEventArgs_internal } from "./GridFilterExpressionsEventArgs";
var IgrGridFilterExpressionsEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridFilterExpressionsEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrGridFilterExpressionsEventArgs.prototype.createImplementation = function () {
        return new GridFilterExpressionsEventArgs_internal();
    };
    Object.defineProperty(IgrGridFilterExpressionsEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrGridFilterExpressionsEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrGridFilterExpressionsEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrGridFilterExpressionsEventArgs.prototype, "filterExpressions", {
        get: function () {
            if (this.i.a == null) {
                return null;
            }
            if (!this.i.a.externalObject) {
                var e = new IgrFilterExpressionCollection();
                e._implementation = this.i.a;
                this.i.a.externalObject = e;
            }
            return this.i.a.externalObject;
        },
        set: function (v) {
            v == null ? this.i.a = null : this.i.a = v.i;
        },
        enumerable: true,
        configurable: true
    });
    return IgrGridFilterExpressionsEventArgs;
}());
export { IgrGridFilterExpressionsEventArgs };
//# sourceMappingURL=igr-grid-filter-expressions-event-args.js.map
